// /src/components/tools/charts/DivisionBarChart.jsx

import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Register the necessary components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const data = {
  labels: ['Navy', 'Marines', 'Intelligence Services', 'Production Department', 'Ressources Management'],
  datasets: [
    {
      label: '',
      data: [16, 12, 6, 12, 16],
      backgroundColor: [
        '#9c99a3',
        '#9c99a3',
        '#9c99a3',
        '#9c99a3',
        '#9c99a3'
      ],
      borderColor: [
        '#dad8df',
        '#dad8df',
        '#dad8df',
        '#dad8df',
        '#dad8df'
      ],
      borderWidth: 1
    }
  ]
};

const options = {
    indexAxis: 'y', // 'y' for horizontal bar
    elements: {
      bar: {
        borderWidth: 2,
      }
    },
    responsive: true,
    plugins: {
      legend: {
          display: false,
          position: 'right',
      },
      tooltip: {
        enabled: true,
        titleColor: '#dad8df', // Red for tooltip title text
        bodyColor: '#9c99a3', // Blue for tooltip body text
      }
    },
    scales: {
      x: {
        ticks: {
          color: '#9c99a3' // Green color for x-axis tick labels
        },
        title: {
          display: true,
          text: 'Member count',
          color: '#dad8df' // Red color for the axis title
        }
      },
      y: {
        ticks: {
          color: '#dad8df' // Green color for y-axis tick labels
        }
      }
    }
  };
  
  const DivisionBarChart = () => (
    <div className="homepage-division-chart" >
      <Bar data={data} options={options} />
    </div>
  );
  
  export default DivisionBarChart;
  